/**
 * Kiểu phần thưởng của chương trình stamp loyalty.
 * Khai ở đây thay vì dùng lại enum bên settingService, vì màn cấu hình stamp
 * chưa lên main còn màn cashier thì đã lên. Gộp lại khi hai nhánh gặp nhau.
 */
export enum LOYALTY_STAMPS_REWARD_TYPE {
  PERCENTAGE_DISCOUNT = 'PERCENTAGE_DISCOUNT',
  AMOUNT_DISCOUNT = 'AMOUNT_DISCOUNT',
  FREE_SERVICE = 'FREE_SERVICE',
}

/** Một mốc thưởng của chương trình stamp loyalty, cấu hình ở màn Setting > Payments */
export interface IStampLoyaltyReward {
  id: string;
  /** Số stamp cần tích để mở mốc thưởng này */
  stampsRequired: number;
  rewardType: LOYALTY_STAMPS_REWARD_TYPE | string;
  discountValue: number;
  serviceId: string;
  serviceName?: string;
}

/** Response của GET api/v1/customer/stamp-loyalty-info/{customerId} */
export interface IStampLoyaltyInfo {
  /** Shop có bật chương trình stamp loyalty hay không */
  enabled: boolean;
  totalStamp: number;
  totalSlots: number;
  /** Mốc thưởng gần nhất khách chưa đạt, null khi đã đạt hết mọi mốc */
  nextReward: IStampLoyaltyReward | null;
  /** Các mốc khách đã đủ điều kiện nhận */
  availableRewards: IStampLoyaltyReward[];
  /** Toàn bộ mốc thưởng của shop */
  rewards: IStampLoyaltyReward[];
}
